<template>
  <div class="account-center page">
    <van-nav-bar
      :title="$t('账户中心')"
      left-arrow
      @click-left="$router.back()"
    />

    <div class="balance-card">
      <div class="balance-label">{{ $t('账户余额') }}</div>
      <div class="balance-value">{{ $displayMoney(balance) }}</div>
<div
  v-if="$currencyNote()"
  style="font-size: 12px; line-height: 1.5; margin-top: 8px;"
>
  {{ $currencyNote() }}
</div>
    </div>

    <van-cell-group class="account-menu">
      <van-cell
        :title="$t('个人报表')"
        icon="chart-trending-o"
        is-link
        @click="$router.push({path:'/Personalreport'})"
      />
      <van-cell
        :title="$t('任务记录')"
        icon="orders-o"
        is-link
        @click="$router.push({path:'/GameRecord'})"
      />
      <van-cell
        :title="$t('提现记录')"
        icon="balance-list-o"
        is-link
        @click="$router.push({path:'/WithdrawRecord'})"
      />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: 'AccountCenter',
    data() {
    return {
      balance: '--'
    };
  },
  computed: {
    text() {
      const messages = {
        'zh-CN': {
          title: '账户中心',
          balance: '账户余额',
          report: '个人报表',
          gameRecord: '任务记录',
          withdrawRecord: '提现记录'
        },
        'ja-JP': {
          title: 'アカウントセンター',
          balance: '残高',
          report: '利用明細',
          gameRecord: '応援履歴',
          withdrawRecord: '出金履歴'
        },
        'en-US': {
          title: 'Account Center',
          balance: 'Account Balance',
          report: 'Personal Report',
          gameRecord: 'Ranking History',
          withdrawRecord: 'Withdrawal History'
        }
      };
      return messages[this.$i18n.locale] || messages['zh-CN'];
    }
  },
  methods: {
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res && res.code === 200 && res.data) {
          this.balance = res.data.money
        } else if (res && res.msg) {
          this.$translatePublic(res.msg).then(message => this.$toast(message))
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.replace({path:'/Login'})
      return
    }
    this.getUserInfo()
  }
}
</script>

<style scoped>
.account-center {
  min-height: 100vh;
  background: #f5f5f5;
}

.balance-card {
  margin: 16px;
  padding: 24px 20px;
  color: #fff;
  border-radius: 12px;
  background: linear-gradient(135deg, #be9f80, #8f6f52);
  box-shadow: 0 6px 18px rgba(83, 57, 34, 0.16);
}

.balance-label {
  font-size: 14px;
  opacity: 0.88;
}

.balance-value {
  margin-top: 10px;
  font-size: 30px;
  font-weight: 600;
}

.account-menu {
  margin: 16px;
  overflow: hidden;
  border-radius: 10px;
}
</style>
